import * as React from 'react';
import {StyleSheet, TouchableOpacity, View, ViewStyle} from 'react-native';

import BaseEffectImageSequence from '../../../../../shared/BaseEffectImageSequence';

import Effect from '../../../../../../../domain/entities/Effect';

interface Props {
  effect: Effect;
  children?: React.ReactNode;
}

const EffectView: React.FunctionComponent<Props> = props => {
  const {effect} = props;
  const [key, setKey] = React.useState(new Date());
  const onPress = React.useCallback(() => {
    setKey(new Date());
  }, []);
  return (
    <View style={styles.container}>
      <TouchableOpacity style={{flex: 1}} onPress={onPress}>
        <BaseEffectImageSequence
          key={`${key}`}
          id={effect.id}
          urls={effect.centerPositionedEffect.frameUrls}
          size={size}
          loop={false}
        />
      </TouchableOpacity>
    </View>
  );
};

export default React.memo(EffectView);

const width = 320;
const height = 260;
const size = {width, height};

const aspectRatio = width / height;

const styles = StyleSheet.create({
  container: {
    aspectRatio,
    backgroundColor: 'rgba(200, 200, 200, 0.9)',
    height,
    width,
  } as ViewStyle,
});
